import gql from "graphql-tag";

export default gql`
query GetMovie($id: Int!) {
  movie(id: $id) {
    directors {
      id,
      name,
      job,
      profile_path
    },
    cast {
      character,
      name,
      id,
      profile_path
    }
    id
    poster
    displayReleaseDate {
      date
    }
    title
    runtime
    overview
  }
}
`;


// WEBPACK FOOTER //
// ./src/queries/getMovie.ts